import React from 'react';
import moment from 'moment';

export const DateCell = ({ cell }) => {
  const { createdAt } = cell.original;
  
  if (!createdAt) return <span>-</span>;
  
  const date = moment(createdAt);
  
  return (
    <div className="date-cell">
      <span className="date">{date.format('DD/MM/YYYY')}</span>
      <span className="time text-muted">{date.format('HH:mm')}</span>
    </div>
  );
};

